"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityEditionDialog = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var Dialog_1 = require("./Dialog");
var Messages_1 = require("../Messages");
var Button_1 = require("../Button");
/**
 * @internal
 */
exports.CommunityEditionDialog = function (_a) {
    var headerText = _a.headerText, infoText = _a.infoText, copyrightText = _a.copyrightText, links = _a.links, onClose = _a.onClose, closeButtonText = _a.closeButtonText;
    return (react_1.default.createElement(Dialog_1.Dialog, { onClose: onClose, displayCloseButton: true, className: "gd-community-dialog" },
        react_1.default.createElement("h3", { className: "gd-community-dialog-header" }, headerText),
        react_1.default.createElement(Messages_1.Message, { type: "progress", className: "gd-community-dialog-info" }, infoText),
        react_1.default.createElement("div", { className: "gd-community-dialog-copyright" }, copyrightText),
        links.length > 0 ? (react_1.default.createElement("ul", { className: "gd-community-dialog-links" }, links.map(function (link) { return (react_1.default.createElement("li", { key: link.uri },
            react_1.default.createElement("a", { href: link.uri, target: "_blank", rel: "noreferrer noopener" }, link.text))); }))) : null,
        react_1.default.createElement("div", { className: "gd-dialog-footer" },
            react_1.default.createElement(Button_1.Button, { className: "gd-community-button gd-button-secondary", onClick: onClose, value: closeButtonText, title: closeButtonText }))));
};
//# sourceMappingURL=CommunityEditionDialog.js.map